/* Timed story choreography: stable layout anchors, masked type, and opaque image settling. */
document.querySelectorAll('[data-our-story]').forEach(initializeStory);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-our-story]').forEach(initializeStory));
function initializeStory(root){
  // Keep the unwrapped, readable HTML when scroll observation is unavailable.
  if(typeof IntersectionObserver!=='function')return;
  if(root.dataset.motionInitialized)return;
  root.dataset.motionInitialized='true';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)'),desktop=matchMedia('(min-width: 990px)');
  const controller=new AbortController();
  const listen=(node,event,fn,options={})=>node.addEventListener(event,fn,{...options,signal:controller.signal});
  const scenes=[...root.querySelectorAll('[data-scene]')];
  const scroller=()=>desktop.matches?document.querySelector('.page-wrapper')||document.scrollingElement:document.scrollingElement;
  const targets=[...root.querySelectorAll('.os-copy > h1,.os-copy > h2,.os-copy > p,.os-coda,.os-name-content > h2,.os-definition')];
  const entries=targets.map(anchor=>{
    const content=document.createElement('span');content.className='os-reveal-content';
    // A div is valid around the definition's heading/paragraph and the coda's link.
    const inner=anchor.matches('.os-definition,.os-coda')?document.createElement('div'):content;
    inner.className='os-reveal-content';inner.append(...anchor.childNodes);anchor.append(inner);
    if(anchor.matches('.os-intro')){
      const text=inner.textContent,match=text.match(/^(Hi! We’re )(Michele)( and )(Erica)(\.)$/);
      if(match){inner.replaceChildren();match.slice(1).forEach((part,index)=>{const span=document.createElement('span');span.textContent=part;span.className=index===0?'os-intro-greeting':index===1||index===3?'os-founder':'os-intro-join';inner.append(span)});}
    }
    if(anchor.matches('.os-beginning-copy > p')){
      const text=inner.textContent,emphasis=['our Catholic faith','God’s love'].map(phrase=>({start:text.indexOf(phrase),length:phrase.length})).filter(range=>range.start>=0);
      const fragment=document.createDocumentFragment();
      for(const match of text.matchAll(/\S+|\s+/g)){
        if(/^\s+$/.test(match[0])){fragment.append(document.createTextNode(match[0]));continue;}
        const word=document.createElement('span');word.className='os-word';word.textContent=match[0];
        if(emphasis.some(range=>match.index>=range.start&&match.index<range.start+range.length))word.classList.add('os-word--accent');
        fragment.append(word);
      }
      inner.replaceChildren(fragment);
    }
    const headline=anchor.matches('h1,h2');
    if(headline){
      const walker=document.createTreeWalker(inner,NodeFilter.SHOW_TEXT),nodes=[];
      while(walker.nextNode())nodes.push(walker.currentNode);
      nodes.forEach(node=>{
        const fragment=document.createDocumentFragment();
        for(const part of node.textContent.matchAll(/\S+|\s+/g)){
          if(/^\s+$/.test(part[0])){fragment.append(document.createTextNode(part[0]));continue;}
          const mask=document.createElement('span'),piece=document.createElement('span');
          mask.className='os-mask';piece.className='os-piece';piece.textContent=part[0];mask.append(piece);fragment.append(mask);
        }
        node.replaceWith(fragment);
      });
    }
    const delay=anchor.matches('.os-intro')?240:anchor.matches('.os-definition--house')?150:
      anchor.matches('.os-coda,.os-beginning-copy > p+p')?340:
      anchor.matches('.os-mission-copy > p:not(.os-eyebrow)')?220:
      anchor.matches('.os-copy > p:not(.os-eyebrow)')?120:0;
    return {anchor,inner,headline,delay,animation:null,words:[],leaveTimer:null,state:'initial'};
  });
  const byAnchor=new Map(entries.map(entry=>[entry.anchor,entry]));
  // The gallery's grid cells remain fixed while only the image inside each cell moves.
  root.querySelectorAll('.os-float').forEach(img=>{if(img.parentElement.classList.contains('os-tile'))return;const tile=document.createElement('div');tile.className='os-tile';img.before(tile);tile.append(img)});
  const tiles=[...root.querySelectorAll('.os-tile')];
  const media=[...root.querySelectorAll('.os-photo,.os-tile,.os-emblem')].map(node=>({
    anchor:node.matches('.os-emblem')?node.parentElement:node,
    image:node.matches('.os-emblem')?node:node.querySelector('img'),
    emblem:node.matches('.os-emblem'),tile:node.matches('.os-tile'),index:tiles.indexOf(node),
    seen:false,animation:null,timer:null
  }));
  let observer,mediaObserver,frame,timer,lastBookmark,oldWidth=innerWidth,destroyed=false,observerKey='';
  const headerTop=()=>parseFloat(getComputedStyle(root).getPropertyValue('--os-header'))||0;
  const offset=entry=>entry.headline?'none':entry.anchor.matches('.os-definition--halo')?'translateX(-72px)':entry.anchor.matches('.os-definition--house')?'translateX(72px)':'translateY(26px)';
  function stop(entry){entry.animation?.cancel();entry.animation=null;entry.words.forEach(a=>a.cancel());entry.words=[];clearTimeout(entry.leaveTimer);}
  function animatePart(entry,node,frames,options){
    const animation=node.animate(frames,{easing:'cubic-bezier(.22,.75,.2,1)',fill:'backwards',...options});
    entry.words.push(animation);animation.onfinish=()=>{animation.cancel();entry.words=entry.words.filter(a=>a!==animation)};
  }
  function transition(entry,show){
    if(destroyed||reduced.matches)return;
    clearTimeout(entry.leaveTimer);
    const state=show?'visible':'hidden';if(entry.state===state)return;
    const current=getComputedStyle(entry.inner),from={opacity:current.opacity,transform:current.transform};
    const partial=Number(current.opacity)>.05&&Number(current.opacity)<.95;
    stop(entry);entry.state=state;entry.anchor.dataset.reveal=state;
    const to={opacity:show?1:0,transform:show?'none':offset(entry)};
    entry.inner.style.opacity=String(to.opacity);entry.inner.style.transform=to.transform;
    const duration=show?(entry.headline?700:1050):350;
    const animation=entry.inner.animate([from,to],{duration,delay:show&&!partial?entry.delay:0,easing:'cubic-bezier(.22,.75,.2,1)',fill:'both'});
    entry.animation=animation;
    animation.onfinish=()=>{if(entry.animation===animation){animation.cancel();entry.animation=null}};
    if(!show||partial)return;
    if(entry.headline){
      // Group by actual rendered lines; the same words reflow naturally at any font size.
      const pieces=[...entry.inner.querySelectorAll('.os-piece')];let row=-1,lastTop=-Infinity,column=0;
      pieces.forEach(piece=>{
        const top=piece.offsetTop;if(Math.abs(top-lastTop)>5){row++;column=0;lastTop=top;}
        animatePart(entry,piece,[{transform:'translateY(108%)'},{transform:'none'}],{duration:950,delay:Math.min(row*110+column++*36,330)});
      });
    }else{
      entry.inner.querySelectorAll('.os-word,.os-founder').forEach((word,index)=>{
        const founder=word.matches('.os-founder');
        animatePart(entry,word,[{opacity:.12,transform:'translateY(.4em)'},{opacity:1,transform:'none'}],{duration:founder?950:800,delay:entry.delay+Math.min(index*(founder?170:30),460)});
      });
      if(entry.anchor.matches('.os-definition')){
        const paragraph=entry.inner.querySelector('p');
        if(paragraph)animatePart(entry,paragraph,[{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'none'}],{duration:850,delay:entry.delay+230});
      }
    }
  }
  function resetMedia(){media.forEach(item=>{clearTimeout(item.timer);item.animation?.cancel();item.animation=null;item.seen=false;});}
  function settleImage(item){
    if(item.seen||reduced.matches)return;item.seen=true;
    const {emblem,tile}=item;
    const start=emblem?'scale(.9)':tile?`scale(1.085) translateX(${item.index%2?'-':'+'}2.5%)`:'scale(1.065)';
    const animation=item.image.animate([{transform:start},{transform:'none'}],{duration:emblem?1400:tile?1750:2300,delay:tile?(item.index%4)*90:0,easing:'cubic-bezier(.16,.65,.25,1)',fill:'backwards'});
    item.animation=animation;animation.onfinish=()=>{animation.cancel();if(item.animation===animation)item.animation=null;};
  }
  function configure(){
    const header=document.querySelector('header-component'),section=header?.closest('.header-section');
    const sticks=section&&['sticky','fixed'].includes(getComputedStyle(section).position);
    root.style.setProperty('--os-header',Math.round(sticks?header.getBoundingClientRect().height:0)+'px');
    root.dataset.motion=reduced.matches?'off':'on';
    const key=[desktop.matches,reduced.matches,headerTop()].join(':');
    if(key===observerKey)return;observerKey=key;observer?.disconnect();mediaObserver?.disconnect();resetMedia();
    if(reduced.matches){entries.forEach(entry=>{stop(entry);entry.state='visible';entry.anchor.dataset.reveal='visible';entry.inner.style.opacity='1';entry.inner.style.transform='none'});return;}
    entries.forEach(entry=>{
      if(entry.state==='initial'){entry.inner.style.opacity='0';entry.inner.style.transform=offset(entry);entry.state='hidden';entry.anchor.dataset.reveal='hidden';}
    });
    observer=new IntersectionObserver(changes=>changes.forEach(change=>{
      const entry=byAnchor.get(change.target);if(!entry)return;
      if(change.isIntersecting){clearTimeout(entry.leaveTimer);transition(entry,true)}
      else if(!entry.anchor.contains(document.activeElement)){
        clearTimeout(entry.leaveTimer);entry.leaveTimer=setTimeout(()=>transition(entry,false),120);
      }
    }),{root:desktop.matches?scroller():null,threshold:0,rootMargin:`-${Math.min(headerTop()+32,innerHeight*.25)}px 0px -${Math.min(120,innerHeight*.12)}px 0px`});
    entries.forEach(entry=>observer.observe(entry.anchor));
    mediaObserver=new IntersectionObserver(changes=>changes.forEach(change=>{
      const item=media.find(item=>item.anchor===change.target);if(!item)return;
      if(change.isIntersecting){clearTimeout(item.timer);settleImage(item)}
      else{clearTimeout(item.timer);item.timer=setTimeout(()=>{item.seen=false;item.animation?.cancel();item.animation=null},240)}
    }),{root:desktop.matches?scroller():null,threshold:0});
    media.forEach(item=>mediaObserver.observe(item.anchor));
  }
  // One deliberate desktop gesture advances one fitting chapter. Oversized chapters
  // and constrained reading layouts keep native scrolling through every line.
  let guideFrame=0,guideTarget=null,guideDirection=0,lastWheel=0,wheelAmount=0,gestureHeld=false;
  const finePointer=matchMedia('(hover: hover) and (pointer: fine)');
  function cancelGuide(){cancelAnimationFrame(guideFrame);guideFrame=0;guideTarget=null;wheelAmount=0;gestureHeld=false;}
  function guideAllowed(){
    return !reduced.matches&&desktop.matches&&finePointer.matches&&innerHeight>=600&&
      parseFloat(getComputedStyle(document.documentElement).fontSize)<=24&&
      !document.querySelector('dialog[open],[aria-modal="true"]:not([hidden])')&&
      !document.querySelector('header-component [aria-expanded="true"]');
  }
  function travelTo(target,direction){
    cancelAnimationFrame(guideFrame);
    const s=scroller(),from=s.scrollTop,distance=target-from,start=performance.now();
    guideTarget=target;guideDirection=direction;gestureHeld=true;
    const duration=Math.min(1200,Math.max(850,Math.abs(distance)*.9));
    const step=now=>{
      if(destroyed||!guideAllowed()){cancelGuide();return;}
      const progress=Math.min(1,(now-start)/duration),ease=progress<.5?8*progress**4:1-((-2*progress+2)**4)/2;
      s.scrollTo({top:from+distance*ease,behavior:'instant'});
      if(progress<1)guideFrame=requestAnimationFrame(step);
      else{guideFrame=0;guideTarget=null;}
    };
    guideFrame=requestAnimationFrame(step);
  }
  function guideWheel(event){
    if(event.defaultPrevented||event.ctrlKey||event.metaKey||Math.abs(event.deltaX)>Math.abs(event.deltaY)||!guideAllowed()){cancelGuide();return;}
    if(event.target.closest('a,button,input,textarea,select,[contenteditable],dialog,header-component'))return;
    const direction=Math.sign(event.deltaY);if(!direction)return;
    const now=performance.now(),gap=now-lastWheel;lastWheel=now;
    const fresh=gap>200;
    if(gestureHeld&&direction===guideDirection&&!fresh){event.preventDefault();return;}
    if(guideFrame){
      if(direction!==guideDirection){cancelGuide();}
      else{event.preventDefault();return;}
    }
    if(fresh||direction!==guideDirection){gestureHeld=false;wheelAmount=0;}
    const s=scroller(),available=innerHeight-headerTop();
    const positions=scenes.map(scene=>({scene,top:scene.getBoundingClientRect().top+s.scrollTop-headerTop(),height:scene.offsetHeight}));
    const current=positions.findIndex(item=>Math.abs(item.top-s.scrollTop)<64);
    if(current<0||positions[current].height>available+3)return;
    const next=current+direction;if(next<0||next>=positions.length)return;
    // Native flow takes over when the destination needs more than one screen.
    if(positions[next].height>available+3)return;
    const target=positions[next].top;if(Math.abs(target-s.scrollTop)<5)return;
    wheelAmount+=Math.abs(event.deltaY)*(event.deltaMode===1?16:event.deltaMode===2?available:1);guideDirection=direction;
    if(wheelAmount>=36){event.preventDefault();wheelAmount=0;travelTo(target,direction);}
  }
  listen(root,'wheel',guideWheel,{passive:false});
  listen(document,'keydown',cancelGuide,{capture:true});
  listen(document,'pointerdown',cancelGuide,{capture:true});
  listen(document,'touchstart',cancelGuide,{capture:true,passive:true});
  listen(window,'resize',cancelGuide);
  listen(reduced,'change',cancelGuide);
  listen(document,'visibilitychange',cancelGuide);
  function bookmark(){
    const top=headerTop()+10,rect=root.getBoundingClientRect();
    if(innerWidth!==oldWidth||rect.top>=top||rect.bottom<=top)return;
    const index=Math.max(0,scenes.findLastIndex(scene=>scene.getBoundingClientRect().top<=top)),scene=scenes[index];
    lastBookmark={scene,ratio:(top-scene.getBoundingClientRect().top)/scene.offsetHeight,atStart:scroller().scrollTop<160};
  }
  function resize(){clearTimeout(timer);timer=setTimeout(()=>{
    if(destroyed)return;const changed=oldWidth!==innerWidth,saved=lastBookmark;configure();
    if(changed&&saved&&!saved.atStart){const s=scroller(),r=saved.scene.getBoundingClientRect();s.scrollTo({top:r.top+s.scrollTop+saved.ratio*saved.scene.offsetHeight-headerTop()-10,behavior:'instant'});}
    oldWidth=innerWidth;bookmark();
  },160)}
  listen(document,'scroll',()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=null;bookmark()})},{capture:true,passive:true});
  listen(window,'resize',resize);listen(reduced,'change',configure);
  listen(root,'focusin',event=>{entries.filter(entry=>entry.anchor.contains(event.target)).forEach(entry=>{stop(entry);entry.state='visible';entry.anchor.dataset.reveal='visible';entry.inner.style.opacity='1';entry.inner.style.transform='none'})});
  listen(document,'shopify:section:unload',event=>{if(!event.target.contains(root))return;destroyed=true;cancelGuide();observer?.disconnect();mediaObserver?.disconnect();resetMedia();entries.forEach(stop);controller.abort();clearTimeout(timer);cancelAnimationFrame(frame)});
  configure();document.fonts.ready.then(()=>{if(!destroyed)resize()});
}
